/**
 * Japanese national holidays (from 出勤簿 祝日・日付 tab).
 * Keys are YYYY-MM-DD.
 */
export const JAPAN_PUBLIC_HOLIDAYS = {
  "2026-01-01": "元日",
  "2026-01-12": "成人の日",
  "2026-02-11": "建国記念の日",
  "2026-02-23": "天皇誕生日",
  "2026-03-20": "春分の日",
  "2026-04-29": "昭和の日",
  "2026-05-03": "憲法記念日",
  "2026-05-04": "みどりの日",
  "2026-05-05": "こどもの日",
  "2026-05-06": "休日",
  "2026-07-20": "海の日",
  "2026-08-11": "山の日",
  "2026-09-21": "敬老の日",
  "2026-09-22": "休日",
  "2026-09-23": "秋分の日",
  "2026-10-12": "スポーツの日",
  "2026-11-03": "文化の日",
  "2026-11-23": "勤労感謝の日",
};

/** @type {Record<string, string>} */
export const JAPAN_PUBLIC_HOLIDAYS_EN = {
  "2026-01-01": "New Year's Day",
  "2026-01-12": "Coming of Age Day",
  "2026-02-11": "National Foundation Day",
  "2026-02-23": "Emperor's Birthday",
  "2026-03-20": "Vernal Equinox Day",
  "2026-04-29": "Showa Day",
  "2026-05-03": "Constitution Memorial Day",
  "2026-05-04": "Greenery Day",
  "2026-05-05": "Children's Day",
  "2026-05-06": "Holiday",
  "2026-07-20": "Marine Day",
  "2026-08-11": "Mountain Day",
  "2026-09-21": "Respect for the Aged Day",
  "2026-09-22": "Holiday",
  "2026-09-23": "Autumnal Equinox Day",
  "2026-10-12": "Sports Day",
  "2026-11-03": "Culture Day",
  "2026-11-23": "Labour Thanksgiving Day",
};

/** @param {string} dateKey YYYY-MM-DD */
export function publicHolidayLabel(dateKey) {
  return JAPAN_PUBLIC_HOLIDAYS[dateKey] || "";
}

/** @param {string} dateKey YYYY-MM-DD */
export function publicHolidayLabelEn(dateKey) {
  return JAPAN_PUBLIC_HOLIDAYS_EN[dateKey] || "";
}
